

(function($, App, Utils){
  'use strict';

  var logger = new Logger('DataLink');

  Utils.add('DataLink', {

    linkManager: function($this) {

      var self = $this,
        url = self.data('link'),
        target = self.data('linkTarget'),
        external = url.match(/^http(s)?:\/\//) != null || target == '_blank' || target == 'external';

      if ( App.Body.is('.editmode') ) {
        logger.info("Edit mode, skipping redirect: ", url);
        return;
      }

      if (url.match(/^#/) != null) {
        logger.log("Anchor called %s requested", url);
        return;
      }

      logger.info("leading to: ", url);

      if (external) {
        window.open(url);
      } else {
        window.location.href = url;
      }
    },

    bindEvents: function(rebind) {

      logger.log(rebind ? "(re)bind events" : "bind events");

      Utils.DataLink.unbindEvents();

      var $links = $('*[data-link]').not('.editmode *[data-link]').not('[data-link=""]');
      var $selectLinks = $('*[data-select-link]');

      $links.prop('role', 'link').prop('tabindex', 0);

      $links.find('a').on('click.data-link', function(e) {
        e.stopPropagation();
      });

      $links.on('click.data-link', function() {
        Utils.DataLink.linkManager($(this));
      });

      $links.on( "keydown", function(event) {
        if(event.which == 13)
          Utils.DataLink.linkManager($(this));
      });

      $selectLinks.on('change.data-link', function() {
        Utils.DataLink.linkManager($(this).find(':selected'));
      });

      App.Window.on("disable:links", function() {
        Utils.DataLink.unbindEvents();
      });

      JsBarcode("svg.barcode").init(); // per i barcode, non per i link... non ho trovato altri js più generici
    },

    unbindEvents: function() {
      var $links = $('*[data-link], *[data-select-link]').not('[data-link=""], [data-select-link=""]');
      $links.off('click.data-link').off('change.data-link');
      $links.find('a').off('click.data-link');
    },

    init: function() {
      this.bindEvents();
      App.Window.on(Utils.Ajax.Events.Success, function() {
        Utils.DataLink.bindEvents(true);
      });
    }

  });

})(jQuery, window.App, window.App.Utils);
